<form [formGroup]="businessForm" class="flex flex-col gap-4">
  <div>
    <h3><label class="block" for="name">Business name</label></h3>
    <div class="text-sm text-night-lighter">This is how your business will appear in Hospitable.</div>
    <mat-form-field class="nopadding">
      <input matInput formControlName="name" placeholder="Property Pro LLC" />
    </mat-form-field>
  </div>

  <div>
    <h3><label class="block" for="type">Business model</label></h3>
    <div class="text-sm text-night-lighter mb-4">Select the model that best describes your business.</div>
    <div class="flex flex-col md:flex-row gap-6 mb-8">
      <sbnb-radio-card
        [disabled]="businessForm.get('type').disabled"
        [selected]="businessForm.get('type').value === 'owner'"
        (click)="setType('owner')">
        <h3 class="mb-2">Owner</h3>
        <p>I own the properties that I manage.</p>
      </sbnb-radio-card>
      <sbnb-radio-card
        [disabled]="businessForm.get('type').disabled"
        [selected]="businessForm.get('type').value === 'property_manager'"
        (click)="setType('property_manager')">
        <h3 class="mb-2">Manager</h3>
        <p>I manage or co-host properties for other owners.</p>
      </sbnb-radio-card>
    </div>
  </div>

  <!-- Properties -->
  <div>
    <h3>
      <label class="block" for="properties">
        Select the properties you own and manage
        {{ businessForm.get('name').value ? 'under ' + businessForm.get('name').value : '' }}.
      </label>
    </h3>
    <div class="text-sm text-night mb-4">
      Owning a property and managing it yourself has unique tax implications and benefits. We'll recommend an Accounting
      structure for these properties that enables you to take advantage of tax benefits available for self-managers.
    </div>

    <sbnb-loading-spinner *ngIf="loadingProperties$ | async" class="mt-4"></sbnb-loading-spinner>
    <ng-container *ngIf="properties$ | async as properties">
      <section
        class="border border-smoke rounded p-4 max-h-96 overflow-y-auto"
        formGroupName="properties"
        *ngIf="properties.length > 0; else noProperties">
        <mat-checkbox
          *ngFor="let property of properties"
          [matTooltip]="
            businessForm.get('properties.' + property.id).disabled
              ? 'This property is already assigned to another business'
              : ''
          "
          class="w-full"
          [formControlName]="property.id">
          <div class="flex items-center gap-2">
            <img [src]="property.picture" alt="Property image" class="w-7 h-5 rounded" />
            <span class="flex-1">{{ property.name }}</span>
            <sbnb-icon
              icon="alert-triangle"
              *ngIf="property?.owners?.length && property?.commissionRates?.length && type.value === 'owner'"
              matTooltip="This property is currently set up for owner's statements."
              class="text-lemon-darker"></sbnb-icon>
          </div>
        </mat-checkbox>
      </section>
      <mat-error *ngIf="businessForm.get('properties')?.errors?.['groupMin']">
        At least one property must be selected
      </mat-error>

      <ng-template #noProperties>
        <sbnb-no-items icon="properties">No properties found</sbnb-no-items>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="selectedOSProperties$ | async as selectedOSProperties">
      <sbnb-alert-card *ngIf="selectedOSProperties?.length" context="warning" class="mt-4">
        <div>
          <h3>All Owner Statements will be deleted for this property, and cannot be undone.</h3>
          <p>
            {{ selectedOSProperties.length === 1 ? 'This property is' : 'These properties are' }} currently set up with
            the “Manager” business model, using Reservation commission agreements to generate monthly Owner Statements.
          </p>
          <p>
            By switching to the “Owner” business model, you'll unlock features tailored for owned properties — including
            a Profit & Loss Report.
          </p>
          <p class="strong">
            However, this change will permanently delete all existing Owner Statements for this property. This action
            cannot be undone.
          </p>
          <mat-checkbox formControlName="confirmation" class="confirmation">
            I understand that Owner Statements will be permanently deleted for these properties:
            <span class="flex flex-col ml-4">
              <span *ngFor="let property of selectedOSProperties">{{ property.name }}</span>
            </span>
          </mat-checkbox>
        </div>
      </sbnb-alert-card>
    </ng-container>
  </div>

  <div class="flex justify-end gap-4">
    <sbnb-button type="secondary" label="Nevermind" [routerLink]="['/operations/my-business/businesses']"></sbnb-button>
    <sbnb-button
      type="primary"
      label="Save"
      (clicked)="save()"
      [disabled]="businessForm.invalid || !businessForm.dirty"
      [loading]="saving$ | async"
      loadingLabel="Saving..."></sbnb-button>
  </div>
</form>
